import { useState, useRef, useEffect } from "react";
import Datetime from "react-datetime";
import moment from "moment";
import "moment/locale/th";
import "react-datetime/css/react-datetime.css";
import { createPortal } from "react-dom";
moment.locale("th");

const formatThaiDate = (date, mode) => {
  if (!date) return "";
  const m = moment(date, ["YYYY-MM", "YYYY-MM-DD"], true);

  if (!m.isValid()) return "";

  return mode === "month"
    ? m.add(543, "year").format("MM/YYYY")
    : m.add(543, "year").format("DD/MM/YYYY");
};



const DatePicker = ({ label, name, value, onChange, disabled, mode = "date" }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
  const inputRef = useRef(null);
  const calendarRef = useRef(null);
  const isMonthPicker = mode === "month";

  const handleOpenCalendar = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
    setShowCalendar(true);

    setTimeout(() => fixBuddhistHeader(), 20); // 👈 เพิ่มบรรทัดนี้
  };

  const handleOutsideClick = (e) => {
    if (
      calendarRef.current &&
      !calendarRef.current.contains(e.target) &&
      !inputRef.current.contains(e.target)
    ) {
      setShowCalendar(false);
    }
  };

  useEffect(() => {
    if (!showCalendar) return;

    const picker = document.querySelector(".rdtPicker");
    if (!picker) return;

    const header = picker.querySelector(".rdtSwitch");
    if (!header) return;

    const observer = new MutationObserver(() => {
      fixBuddhistHeader();
    });

    observer.observe(header, { childList: true, characterData: true, subtree: true });

    return () => observer.disconnect();
  }, [showCalendar]);


  if (showCalendar) {
    document.addEventListener("mousedown", handleOutsideClick);
  } else {
    document.removeEventListener("mousedown", handleOutsideClick);
  }

  const fixBuddhistHeader = () => {
    setTimeout(() => {
      const header = document.querySelector(".rdtPicker .rdtSwitch");
      if (!header) return;

      let text = header.textContent.trim();

      // เดือน + ปี เช่น "มิถุนายน 2025"
      if (/^\D+\s\d{4}$/.test(text)) {
        const parts = text.split(" ");
        const year = parseInt(parts[1]);

        // บวกเฉพาะถ้าเป็น ค.ศ.
        if (year < 2500) {
          parts[1] = (year + 543).toString();
          header.textContent = parts.join(" ");
        }
        return;
      }

      // ปีล้วน เช่น "2025"
      if (/^\d{4}$/.test(text)) {
        const year = parseInt(text);

        // บวกเฉพาะถ้าเป็น ค.ศ.
        if (year < 2500) {
          header.textContent = (year + 543).toString();
        }
        return;
      }
    }, 10);
  };


  

  return (
    <div className="d-flex align-items-center" style={{ position: "relative" }}>
      {label && <label htmlFor={name} className="form-label">{label}</label>}

      {/* กล่อง Input */}
      <div className="input-group" style={{ position: "relative" }}>
        <input
          ref={inputRef}
          type="text"
          className="form-control input-spacing"
          disabled
          name={name}
          value={value ? formatThaiDate(value, mode) : ""}
          placeholder={isMonthPicker ? "กรุณาเลือกเดือน/ปี" : "กรุณาระบุวันที่"}
          style={{ width: "200px", backgroundColor: "#fff", cursor: "pointer" }}
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={(e) => {
            e.stopPropagation();
            if (showCalendar) setShowCalendar(false);
            else handleOpenCalendar(); //  เรียกฟังก์ชันใหม่แทน toggle เดิม
          }}
          disabled={disabled}
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            height: "100%",
            padding: "0 10px",
            zIndex: 3,
          }}
        >
          <i className="fas fa-calendar"></i>
        </button>
      </div>

      {/* ปฏิทิน */}
      {showCalendar && position.top > 0 &&
        createPortal(
          <div
            ref={calendarRef}
            style={{
              position: "fixed",
              top: `${position.top}px`,
              left: `${position.left}px`,
              zIndex: 99999,
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              width: `${position.width}px`,
              padding: "8px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Datetime
              name={name}
              value={value ? moment(value, ["YYYY-MM", "YYYY-MM-DD"], true) : null}
              onChange={(date) => {
                const formattedValue = moment(date).format(isMonthPicker ? "YYYY-MM" : "YYYY-MM-DD");
                onChange(formattedValue, name);
                setShowCalendar(false);
              }}
              onNavigate={() => fixBuddhistHeader()}

              dateFormat={isMonthPicker ? "YYYY-MM" : "YYYY-MM-DD"}
              viewMode={isMonthPicker ? "months" : "days"}
              timeFormat={false}
              locale="th"
              closeOnSelect={true}
              inputProps={{ hidden: true }}
              renderMonth={(props, month) => (
                <td {...props}>{moment().month(month).format("MMMM")}</td>
              )}
              renderYear={(props, year) => (
                <td {...props}>{year + 543}</td>
              )}
            />
          </div>,
          document.body
        )}

      <style>{`
        .rdtPicker {
          display: block !important;
          opacity: 1 !important;
          visibility: visible !important;
          position: relative !important;
          z-index: 100000 !important;
          background: #fff !important;
        }
      `}</style>
    </div>
  );
};

export default DatePicker;
